import React, { useEffect, useState } from "react";
// const HubUserContext = React.createContext();

// function HubUserProvider({ children, asUser }) {
//   const [hubspotUser, setHubspotUser] = useState({ user: null, vid: null });
//   const [hubspotCookie, setHubspotCookie] = useState(asUser);
//   useEffect(() => {
//     if (!hubspotCookie) {
//       //console.log("scraping cookie");
//       setHubspotCookie(
//         document.cookie.replace(
//           /(?:(?:^|.*;\s*)hubspotutk\s*=\s*([^;]*).*$)|^.*$/,
//           "$1"
//         )
//       );
//     }
//     if (hubspotCookie) {
//       //console.log("cookie:", hubspotCookie);
//       const params = asUser ? "&vid=true" : "";
//       const url = `https://json.watermarksmartdesign.com/willswellness-hs.php?cookie=${hubspotCookie +
//         params}`;
//       const oldData = { ...hubspotUser };
//       //console.log(oldData);
//       const { vid, status } = oldData ? oldData : { vid: null };
//       if (vid === null && status !== "error") {
//         fetch(url)
//           .then((response) => response.json())
//           .then((data) => {
//             console.log("fetched", data);
//             return oldData === undefined || oldData !== data
//               ? setHubspotUser(data)
//               : null;
//           });
//         //.catch((err) => console.log(err));
//       } else {
//         //setHubspotUser({ status: "error" });
//         //console.log(status);
//       }
//     }
//   }, [asUser, hubspotCookie, hubspotUser]);
//   const resetForm = () => setHubspotUser({ user: null });
//   //console.log(hubspotUser, resetForm);
//   return (
//     <HubUserContext.Provider value={{ user: hubspotUser, reset: resetForm }}>
//       {children}
//     </HubUserContext.Provider>
//   );
// }
// function useHubUserState() {
//   const context = React.useContext(HubUserContext);
//   if (context === undefined) {
//     throw new Error("useHubUserState must be used within a HubUserProvider");
//   }
//   return context;
// }

// const isValidUser = (data) => {
//   const { status } = data;
//   return (
//     status !== "error" &&
//     data &&
//     data.properties &&
//     data.properties.has_completed_video_unlock_form &&
//     data.properties.has_completed_video_unlock_form.value &&
//     data.properties.has_completed_video_unlock_form.value === "true"
//   );
// };

// export { HubUserProvider, useHubUserState, HubUserContext, isValidUser };
